// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__J0buM","signatureButtonsRight":"ModalSign_signatureButtonsRight__7g47A"};